"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("antd/lib/button"));

var _card = _interopRequireDefault(require("antd/lib/card"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var selectors = _interopRequireWildcard(require("../../../../redux/selectors"));

var _reselect = require("reselect");

var _reactRedux = require("react-redux");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ParticipantDemographicsCard extends _react.Component {
  render() {
    const {
      studyArm,
      participant,
      editClickHandler,
      showSurveys,
      showReferrals
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_card.default, {
      key: "view"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "profile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "profile-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "First Name")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.firstName)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Last Name")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.lastName)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Username")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.username)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Email")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.email)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Mobile")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.mobile)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      style: {
        alignSelf: 'flex-start'
      }
    }, /*#__PURE__*/_react.default.createElement("label", null, "Address")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.address1 ? participant.address1 : participant.address1, /*#__PURE__*/_react.default.createElement("br", null), participant.address2 ? `${participant.address2}` : '', participant.address2 ? /*#__PURE__*/_react.default.createElement("br", null) : '', `${participant.city ? participant.city : ''}, ${participant.state ? participant.state : ''} ${participant.postalCode ? participant.postalCode : ''}`)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Date of Birth")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.dateOfBirth ? (0, _moment.default)(participant.dateOfBirth).format('MM/DD/YYYY') : '')), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Age")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.dateOfBirth ? (0, _moment.default)().diff(participant.dateOfBirth, 'years') : '')), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Sex at Birth")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.genderAtBirth)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Gender Identity")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.genderIdentity)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Ethnicity")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.ethnicity))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Created Date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, (0, _moment.default)(participant.createDate).format('MM/DD/YYYY'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Status")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.status)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Access Code")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.accessCode)), showReferrals && /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Referral Code")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.referralCode)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Pin")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.pin)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Mobile OS")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.mobileOs))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Applied Date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.appliedDate ? (0, _moment.default)(participant.appliedDate).format('MM/DD/YYYY') : null)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Accepted Date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.acceptedDate ? (0, _moment.default)(participant.acceptedDate).format('MM/DD/YYYY') : null)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Start Date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.startDate ? (0, _moment.default)(participant.startDate).format('MM/DD/YYYY') : null)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "End Date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.endDate ? (0, _moment.default)(participant.endDate).format('MM/DD/YYYY') : null)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Mobile Enroll Date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.mobileEnrollmentDate ? (0, _moment.default)(participant.mobileEnrollmentDate).format('MM/DD/YYYY') : null))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row",
      style: {
        alignItems: 'flex-start'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "About Me")), /*#__PURE__*/_react.default.createElement("textarea", {
      rows: 3,
      style: {
        width: '250px',
        overflowY: 'visible'
      },
      readOnly: true
    }, participant.aboutMe)))), /*#__PURE__*/_react.default.createElement("div", {
      className: "actions"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: editClickHandler
    }, "Edit")))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  showSurveys: selectors.getSurveysFeatureEnabled,
  showReferrals: selectors.getReferralsFeatureEnabled
});

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(ParticipantDemographicsCard);

exports.default = _default;